export default "__VITE_ASSET__Cb1fy$Ng__"